import { createInventoryPdf } from "./inventoryPdf";

// Explicit resource opt-in prevents accidentally exporting rental Products here.
export const createEventPropsPdf = (items, options = {}) => createInventoryPdf(items, { ...options, eventProps: true });
